// The year and years views sit on --view-surface rather than on the theme's
// paper: the gray in the seasons and night themes, the light paper in the day
// one. They change places by sliding 60px, so for that beat neither covers the
// whole screen and the calendar would show through the gap — the shell has to
// wear the same surface while either of them is up. The rule is in index.html;
// this raises and drops it.
//
// No counter needed: the router runs a page's exit before the next page's
// enter, and an exit always knows where it is going. So each of the two asks
// for the surface on the way in, and keeps it on the way out only when the page
// it is handing over to is the other one.
export const viewShell = (on: boolean) =>
    document.documentElement.classList.toggle('view-shell', on)
